export const createAnnouncementsAPI = (request) => ({
  list: async () => {
    const response = await request('/announcements-get');
    return response.data;
  },

  update: async (announcementData) => {
    const response = await request('/announcements-update', {
      method: 'PUT',
      body: JSON.stringify({ data: announcementData }),
    });
    return response.data;
  },

  delete: async (announcementId, organizationId) => {
    const response = await request('/announcements-update', {
      method: 'PUT',
      body: JSON.stringify({
        data: {
          id: announcementId,
          organization_id: organizationId,
          _delete: true
        }
      }),
    });
    return response.data;
  }
}); 